// extracted by mini-css-extract-plugin
export default {"title":"FeaturesCards_title__SaIRa","description":"FeaturesCards_description__36Ri9","card":"FeaturesCards_card__lB8+G","cardTitle":"FeaturesCards_cardTitle__6Rnyf"};